import { NotFound } from 'component/errors/not-found';
import { Redirect } from 'expo-router';
import { getDeploymentConfig } from 'util/util';

export default function Home() {
    const { defaultToAdminDash } = getDeploymentConfig() ?? {};

    if (defaultToAdminDash) {
        return (
            <Redirect
                href={{
                    pathname: '/[siloKey]/admin/one',
                    params: {
                        siloKey: 'test',
                    },
                }}
            />
        );
    }

    return <NotFound />;
}
